var filter = require('./filter');

    /**
     * Remove all null/undefined items from array.
     */
    function compact(arr) {
        return filter(arr, function(val){
            return (val != null);
        });
    }

    module.exports = compact;




//////////////////
// WEBPACK FOOTER
// ./~/mout/array/compact.js
// module id = 1546
// module chunks = 0 1 2